import React, { useEffect, useState } from "react";
import "./options.scss";
import useWeb3 from "../../hooks/useWeb3";
import { useWeb3React } from "@web3-react/core";
import audioManager from "../../utils/AudioManajer.js";
const Options = ({ theme, toggleTheme }) => {
  const [isMuted, setIsMuted] = useState(audioManager.getMuted());
  console.log(isMuted, "isMuted");

  const toggleMute = (e) => {
    const newMutedState = !isMuted;
    setIsMuted(newMutedState);
    audioManager.setMuted(newMutedState);
    console.log("Mute toggled:", newMutedState);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentMuted = audioManager.getMuted();
      if (currentMuted !== isMuted) {
        setIsMuted(currentMuted);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [isMuted]);

  return (
    <>
      <section className="optionsmain">
        <h6 className="optionhead">Options</h6>
        <div className="mainoption">
          <div className="inneroption">
            <p className="optionpara">Theme</p>
            <div className="toggle-container">
              <input
                type="checkbox"
                id="theme-toggle"
                className="theme-toggle"
                checked={theme === "dark"}
                onChange={toggleTheme}
              />
              <label htmlFor="theme-toggle" className="toggle-label">
                <span className="moon">
                  {theme === "light" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <mask id="path-1-inside-1_187_661" fill="white">
                        <path d="M4.75898 0.744141C4.72288 0.830004 4.68842 0.91724 4.65644 1.00586C3.65231 3.78817 5.09396 6.85797 7.87616 7.8623C8.96968 8.25698 10.1072 8.27132 11.1467 7.97754C10.0496 10.588 7.0868 11.9089 4.39276 10.9365C1.61043 9.93224 0.168847 6.86246 1.17304 4.08008C1.78258 2.39122 3.15366 1.19792 4.75898 0.744141Z" />
                      </mask>
                      <path
                        d="M4.75898 0.744141L6.00752 1.26906L7.09791 -1.32449L4.39056 -0.559194L4.75898 0.744141ZM4.65644 1.00586L3.38247 0.546061L3.38246 0.546085L4.65644 1.00586ZM7.87616 7.8623L7.41629 9.13625L7.41636 9.13627L7.87616 7.8623ZM11.1467 7.97754L12.3953 8.5023L13.4851 5.90916L10.7783 6.67419L11.1467 7.97754ZM4.39276 10.9365L3.93293 12.2105L3.93297 12.2105L4.39276 10.9365ZM1.17304 4.08008L-0.100932 3.62028L-0.100935 3.62029L1.17304 4.08008ZM4.75898 0.744141L3.51043 0.219224C3.46669 0.323251 3.4235 0.432375 3.38247 0.546061L4.65644 1.00586L5.93041 1.46566C5.95334 1.4021 5.97906 1.33676 6.00752 1.26906L4.75898 0.744141ZM4.65644 1.00586L3.38246 0.546085C2.1244 4.03201 3.93061 7.87796 7.41629 9.13625L7.87616 7.8623L8.33604 6.58836C6.25731 5.83797 5.18022 3.54432 5.93041 1.46563L4.65644 1.00586ZM7.87616 7.8623L7.41636 9.13627C8.78682 9.6309 10.2144 9.64848 11.515 9.28089L11.1467 7.97754L10.7783 6.67419C10 6.89416 9.15254 6.88305 8.33596 6.58834L7.87616 7.8623ZM11.1467 7.97754L9.89805 7.45278C9.07871 9.40233 6.86472 10.3888 4.85256 9.66255L4.39276 10.9365L3.93297 12.2105C7.30889 13.4289 11.0204 11.7737 12.3953 8.5023L11.1467 7.97754ZM4.39276 10.9365L4.8526 9.66257C2.77381 8.91223 1.69676 6.61865 2.44701 4.53987L1.17304 4.08008L-0.100935 3.62029C-1.35906 7.10627 0.447046 10.9523 3.93293 12.2105L4.39276 10.9365ZM1.17304 4.08008L2.44701 4.53988C2.90174 3.27993 3.92328 2.38785 5.12739 2.04748L4.75898 0.744141L4.39056 -0.559194C2.38404 0.00799453 0.663408 1.50251 -0.100932 3.62028L1.17304 4.08008Z"
                        fill="#F6F6F7"
                        mask="url(#path-1-inside-1_187_661)"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <mask id="path-1-inside-1_190_41" fill="white">
                        <path d="M4.75894 0.744049C4.72287 0.829842 4.68933 0.917224 4.65737 1.00577C3.65314 3.78821 5.09466 6.85798 7.8771 7.86221C8.97044 8.25673 10.1074 8.27114 11.1466 7.97745C10.0495 10.5879 7.08674 11.9088 4.39273 10.9364C1.61052 9.9321 0.168871 6.8623 1.173 4.07999C1.78252 2.39119 3.15369 1.19787 4.75894 0.744049Z" />
                      </mask>
                      <path
                        d="M4.75894 0.744049L6.00749 1.26895L7.09787 -1.32468L4.39048 -0.559273L4.75894 0.744049ZM4.65737 1.00577L3.38342 0.545931L3.3834 0.545969L4.65737 1.00577ZM7.8771 7.86221L7.4173 9.13618L7.4174 9.13622L7.8771 7.86221ZM11.1466 7.97745L12.3952 8.50222L13.4851 5.90917L10.7783 6.67409L11.1466 7.97745ZM4.39273 10.9364L3.93285 12.2104L3.93293 12.2104L4.39273 10.9364ZM1.173 4.07999L-0.100971 3.62019L-0.100979 3.62021L1.173 4.07999ZM4.75894 0.744049L3.51038 0.219149C3.46334 0.331036 3.42137 0.440779 3.38342 0.545931L4.65737 1.00577L5.93133 1.4656C5.9573 1.39367 5.9824 1.32865 6.00749 1.26895L4.75894 0.744049ZM4.65737 1.00577L3.3834 0.545969C2.12524 4.03199 3.93125 7.878 7.4173 9.13618L7.8771 7.86221L8.3369 6.58824C6.25806 5.83795 5.18105 3.54443 5.93134 1.46557L4.65737 1.00577ZM7.8771 7.86221L7.4174 9.13622C8.78755 9.63062 10.2145 9.64832 11.515 9.28081L11.1466 7.97745L10.7783 6.67409C10.0002 6.89397 9.15333 6.88284 8.3368 6.58821L7.8771 7.86221ZM11.1466 7.97745L9.89802 7.45267C9.07866 9.40221 6.86465 10.3887 4.85252 9.66246L4.39273 10.9364L3.93293 12.2104C7.30884 13.4288 11.0204 11.7735 12.3952 8.50222L11.1466 7.97745ZM4.39273 10.9364L4.8526 9.66249C2.77387 8.9121 1.69678 6.61846 2.44698 4.53976L1.173 4.07999L-0.100979 3.62021C-1.35904 7.10614 0.44716 10.9521 3.93285 12.2104L4.39273 10.9364ZM1.173 4.07999L2.44697 4.53979C2.90167 3.27993 3.92329 2.38778 5.1274 2.04737L4.75894 0.744049L4.39048 -0.559273C2.3841 0.00794774 0.663358 1.50245 -0.100971 3.62019L1.173 4.07999Z"
                        fill="#13151A"
                        mask="url(#path-1-inside-1_190_41)"
                      />
                    </svg>
                  )}
                </span>
                <span className="sun">
                  {theme === "light" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <circle
                        cx="5.91193"
                        cy="6.01886"
                        r="2.06791"
                        stroke="#13151A"
                        stroke-width="1.43218"
                      />
                      <path
                        d="M6.82129 10.1362L6.84222 11.817L5.17835 11.8377L5.15742 10.157L6.82129 10.1362Z"
                        fill="#13151A"
                      />
                      <path
                        d="M6.82129 0.162598L6.84222 1.84332L5.17835 1.86405L5.15742 0.183323L6.82129 0.162598Z"
                        fill="#13151A"
                      />
                      <path
                        d="M1.86377 6.82129L0.183045 6.84222L0.16232 5.17835L1.84304 5.15742L1.86377 6.82129Z"
                        fill="#13151A"
                      />
                      <path
                        d="M11.8374 6.82129L10.1567 6.84222L10.136 5.17835L11.8167 5.15742L11.8374 6.82129Z"
                        fill="#13151A"
                      />
                      <path
                        d="M2.49463 3.65674L1.29137 2.48309L2.45325 1.2919L3.65651 2.46555L2.49463 3.65674Z"
                        fill="#13151A"
                      />
                      <path
                        d="M9.54639 10.7085L8.34313 9.53485L9.50501 8.34366L10.7083 9.51731L9.54639 10.7085Z"
                        fill="#13151A"
                      />
                      <path
                        d="M8.34326 2.49463L9.51691 1.29137L10.7081 2.45325L9.53445 3.65651L8.34326 2.49463Z"
                        fill="#13151A"
                      />
                      <path
                        d="M1.29199 9.54688L2.46564 8.34362L3.65683 9.5055L2.48318 10.7088L1.29199 9.54688Z"
                        fill="#13151A"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <circle
                        cx="5.91193"
                        cy="6.0186"
                        r="2.06791"
                        stroke="#F6F6F7"
                        stroke-width="1.43218"
                      />
                      <path
                        d="M6.82129 10.136L6.84222 11.8167L5.17835 11.8374L5.15742 10.1567L6.82129 10.136Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M6.82129 0.162567L6.84222 1.84329L5.17835 1.86402L5.15742 0.183292L6.82129 0.162567Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M1.86377 6.82135L0.183045 6.84228L0.16232 5.17841L1.84304 5.15748L1.86377 6.82135Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M11.8374 6.82135L10.1567 6.84228L10.136 5.17841L11.8167 5.15748L11.8374 6.82135Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M2.49463 3.65648L1.29137 2.48283L2.45325 1.29164L3.65651 2.46529L2.49463 3.65648Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M9.54639 10.7083L8.34313 9.53466L9.50501 8.34348L10.7083 9.51712L9.54639 10.7083Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M8.34326 2.49455L9.51691 1.2913L10.7081 2.45318L9.53445 3.65643L8.34326 2.49455Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M1.29199 9.54663L2.46564 8.34338L3.65683 9.50526L2.48318 10.7085L1.29199 9.54663Z"
                        fill="#F6F6F7"
                      />
                    </svg>
                  )}
                </span>
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>
          <div className="inneroption">
            <p className="optionpara">Sounds</p>
            <div className="bordermain">
              <label class="switch">
                <input
                  onChange={toggleMute}
                  checked={isMuted === false}
                  value={isMuted}
                  type="checkbox"
                />
                <span class="slider"></span>
              </label>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Options;